import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDiscardedLine = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 81,
	height: 80,
	viewBox: "0 0 81 80",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M77.8184 71.6003C79.3805 73.1624 79.3805 75.695 77.8184 77.2571C76.2563 78.8192 73.7236 78.8192 72.1615 77.2571L3.30396 8.3996C1.74187 6.8375 1.74187 4.30484 3.30396 2.74274C4.86607 1.18064 7.39873 1.18066 8.96082 2.74275L77.8184 71.6003Z",
		fill: "white",
		stroke: "#191919",
		strokeWidth: 4
	})
});
const ForwardRef = forwardRef(SvgDiscardedLine);
export default ForwardRef;
